import API from "./index";

const testimonial = () => {
  return `portfolio/testimonial/get`;
};

export default {
  getAllTestimonial() {
    return API.post(testimonial());
  },
};
